<template>
  <div id="app">
   <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
@import url("./assets/iconfont/iconfont.css");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.pageTip {
  color: red;
  font-size: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

}

.setBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  height: 100%;
  .el-button {
    margin: 0 !important;
  }
}

</style>
